import { HeaderActionButtons } from "../HeaderActionButtons";
import { ProfileMenu } from "../ProfileMenu";
import {
  ButtonsContainer,
  CloseModalButton,
  Container,
  HeaderMainContent,
  LoadingContainer,
  LogoutButton,
  ModalContainer,
  RestoreSessionButton,
  TimerContainer,
  WarningSvg,
} from "./styles";
import { CircularProgress, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { Close, Warning } from "@mui/icons-material";
import { useAuth } from "../../../Contexts/AuthContext";

export const HeaderContent = ({ logout, accountData }) => {
  const [openModal, setOpenModal] = useState(false);
  const { refleshToken, isLoading, user, formattedTimestamp } = useAuth();

  const onClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (user.sessionTimeout <= 0) {
      setOpenModal(true);
    }
  }, [user.sessionTimeout]);

  const handleRestoreSession = async () => {
    await refleshToken();
    setOpenModal(false);
  };

  return (
    <>
      <Container>
        <HeaderMainContent>
          <TimerContainer title={`${intl.get("session.expiresIn")} ${formattedTimestamp}`}>
            <span className="hidden md:inline">{intl.get("session.expiresIn")} </span>
            <span className="md:hidden">{intl.get("session.expiresInShort")} </span>
            {formattedTimestamp}
          </TimerContainer>
          <div className="flex min-w-0 shrink items-center gap-1 sm:gap-2">
            <HeaderActionButtons />
            <ProfileMenu logout={logout} accountData={accountData} />
          </div>
        </HeaderMainContent>
      </Container>
      <Dialog open={openModal} onClose={onClose}>
        <ModalContainer>
          <CloseModalButton onClick={onClose}>
            <span>{intl.get("words.close")}</span>
            <Close />
          </CloseModalButton>
          <p>{intl.get("session.expiredTitle")}</p>
          <WarningSvg>
            <Warning />
          </WarningSvg>
          <ButtonsContainer>
            {isLoading ? (
              <LoadingContainer>
                <CircularProgress size={"1.5rem"} />
              </LoadingContainer>
            ) : (
              <RestoreSessionButton onClick={handleRestoreSession}>
                {intl.get("session.renewSession")}
              </RestoreSessionButton>
            )}
            <LogoutButton onClick={logout}>{intl.get("session.logoutConfirm")}</LogoutButton>
          </ButtonsContainer>
        </ModalContainer>
      </Dialog>
    </>
  );
};
